<template>
  <div class="verify-email">
    <RegisterEmail v-if="isDN" />
     <NhstRegistration v-else />
  </div>
</template>

<script>

import RegisterEmail from '@elements/RegisterEmail';
import NhstRegistration from './NhstRegistration.vue';
import { addTrackingEvent } from '@root/src/helpers/Tracking';
import { normalizeToLowerSnakeCase } from '@root/src/helpers/trackingLabels';
import { EXTERNAL_CONFIGS } from '@root/src/helpers/ExternalConfigs';
export default {
  name: 'nhst-check-username',
  components: { RegisterEmail, NhstRegistration },
  mounted() {
    this.trackStep('Register Email');
  },
  methods: {
    trackStep(verbalName) {
      const identifierValue = normalizeToLowerSnakeCase(verbalName);
      if (!identifierValue) return;
      let paywallVariation = this.$route.query.paywall_variation_type || '';
      let registrationService = this.$authWebapp.getSource() || '';
      let identifierType = 'registration_step';
      let subProducerContract = { name: 'registration', version: '1' };
      if (!this.isDN) {
        paywallVariation =
          sessionStorage.getItem(
            EXTERNAL_CONFIGS.STORAGE_KEYS.PAYWALL_VARIATION
          ) || '';
        registrationService = paywallVariation ? 'PAYWALL' : 'ORDERFLOW';
        identifierType = 'order_flow_step';
        subProducerContract = { name: 'order_flow', version: '1' };
      }
      addTrackingEvent({
        event: 'system_action',
        sub_producer_contract: subProducerContract,
        attributes: {
          action: 'show',
          identifier_type: identifierType,
          identifier_value: identifierValue,
          registration_service: registrationService,
          paywall_variation: paywallVariation,
          flow_source_url: this.$authWebapp.getTarget('') || '',
        },
      });
    },
  },
};
</script>
